import React, { useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import Spin from 'components/Spin';
import Button from 'components/Button';
import { useSelector, useDispatch } from 'react-redux';
import { selectArticle } from 'store/modules/public/selectors';
import { getArticle } from 'store/modules/public/actions';
import { saveUserArticle } from 'services/article.service';
import toast from 'utils/toast';
import { ConfigContext } from 'context/config';

const Root = styled('div')`
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding-bottom: 5rem;
  padding-top: 2rem;

  .header-logo img {
    width: 200px;
  }
  .section-spacer {
    margin: 4rem 0;
  }
  .xl {
    font-size: 1.6rem;
    font-weight: bold;
  }

  @media only screen and (min-width: 41rem) {
    .xl {
      font-size: calc(5vw + 1.06px);
    }
  }
`;

const LOGO = {
  TIC: '/assets/svg/logo_dark.svg',
  TMG: '/assets/svg/tmg-logo.svg',
};

const Agreement = () => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user.user);
  const { article, loading } = useSelector(selectArticle('tou'));
  const { BRAND } = useContext(ConfigContext);

  useEffect(() => {
    if (!article) {
      dispatch(getArticle('tou', BRAND));
    }
  }, []);

  if (loading || loading === undefined) return <Spin spinning />;
  if (!article) {
    return <Redirect to="/" />;
  }

  const onAccept = () => {
    return saveUserArticle({
      user_article_value: 1,
      user_id: user.user_id,
      article_id: article.article_id,
    }).then(
      () => window.location.replace('/'),
      (e) => toast.error(e.message),
    );
  };

  return (
    <Root>
      <Helmet>
        <title>Membership Agreement</title>
      </Helmet>
      <Container>
        <Grid container spacing={2}>
          <Grid item>
            <Box mb={5}>
              <a href="/">
                <img src={LOGO[BRAND]} />
              </a>
            </Box>
            <Box mb={4}>
              <Typography variant="h1">{article.article_title}</Typography>
            </Box>
            <Box>
              <article>
                <div
                  dangerouslySetInnerHTML={{ __html: article.article_body }}
                />
              </article>
              <Button size="large" onClick={onAccept}>
                Accept Terms
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

export default Agreement;
